import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import FacetedSearchCompact from '../Components/FacetedSearchCompact';
import { FacetedFilterCheckbox } from '../Components/FacetedSearch';
import { AccordionPanel, Accordion } from './Accordion.container';
import { query, submitSearchFacet, toggleVisibleDropdownMenu, searchFacetChange, sliderFilterChange } from '../Actions/FacetedSearch.action';
import SubNav from '../Components/SubNavCompact';
import SortCriteriaCompact from '../Components/SortCriteriaCompact';
import FilterTag from '../Components/FilterTags';
import { translate } from '../Services/translation';
import { PRODUCT_VIEW_CACHED, updateFilterOption, deselectAllFilterOptions } from '../Actions/FacetedSearch.action';
import Svg from '../Components/Svg';
import RangeSlider from '../Components/RangeSlider';

class FacetedSearchCompactContainer extends Component {
    constructor(props) {
        super(props);
        this.handleFacetSearchActionLoading = this.handleFacetSearchActionLoading.bind(this);
        this.currentProductsViewCachedId = null;
        const { facetFilters } = props;
        const filterString = JSON.stringify(facetFilters);
        const overlayActive = false;
        let isLoading = true;
        this.state = {
            facetFilters,
            filterString,
            overlayActive,
            isLoading
        };
    }

    handleFacetSearchActionLoading(event) {
        this.setState((prevState, _) => { return { ...prevState, isLoading: event.detail.isLoading } })
    }

    componentDidMount() {
        this.props.query(decodeURI(window.location.search.substr(1)) || '', false, this.props.productId || '');
        document.addEventListener('facetSearchActionLoading', this.handleFacetSearchActionLoading);
    }

    componentWillUnmount() {
        document.removeEventListener('facetSearchActionLoading', this.handleFacetSearchActionLoading);
    }

    onFacetChange(filter, option) {
        this.setState((prevState, props) => {
            const { facetFilters } = this.state;
            const newFilters = updateFilterOption(facetFilters, filter, option);
            return {
                ...prevState,
                facetFilters: newFilters,
            };
        });
    }

    static getDerivedStateFromProps(nextProp, prevState) {
        if (nextProp.productsViewCachedId !== prevState.productsViewCachedId) {
            return {
                ...prevState,
                ...nextProp,
            }
        }
        return prevState;
    }

    onSearchResultDataChange(dom) {
        if ([null, undefined].includes(dom)) {
            return;
        }
        const container = document.createElement('div');
        container.innerHTML = dom;
        const existingResult = document.querySelector("#search-result");
        const tempResult = container.querySelector("#search-result");
        const existingFilter = existingResult.querySelector('#facetedSearchCompact');
        const tempFilter = tempResult.querySelector('#facetedSearchCompact');
        const replace = (node, newNode) => node.parentNode.replaceChild(newNode, node);
        // move existingFilter from existingResult to tempResult
        replace(tempFilter, existingFilter);
        // replace existingResult with tempResult ( newResult )
        replace(existingResult, tempResult);
        // bootstrap react components if any exists in the search result
        window.__litium.bootstrapComponents();
    }

    componentDidUpdate() {
        const productViewCached = window.__litium.cache ? window.__litium.cache[PRODUCT_VIEW_CACHED] || {} : {};
        if (!productViewCached.used) {
            productViewCached.used = true;
            const dom = productViewCached.productsView;
            dom && this.onSearchResultDataChange(dom);
        }
    }

    activateOverlay() {
        this.setState((prevState, props) => ({
            ...prevState,
            overlayActive: !prevState.overlayActive
        }));
    }
    activeClass() {
        return this.state.overlayActive ? 'active' : '';
    }

    render() {
        const {
            subNavigation = [],
            sortCriteria,
            navigationTheme = '',
            ...facetProps
        } = this.props;
        const { facetFilters } = this.state;
        const facetState = {
            ...facetProps,
            facetFilters,
            onFacetChange: (filter, option) => this.onFacetChange(filter, option),
        };
        const empty = array => !(array && array.length);
        const sortCriterias = !sortCriteria || !sortCriteria.sortItems ? null : sortCriteria.sortItems;

        const hidden = [subNavigation, facetFilters, sortCriteria].every(ele => !ele || ele.length === 0);
        return (
            this.state.isLoading
                ? <div className='compact-filter__skeleton hide-for-large'></div>
                : (hidden
                    ? null 
                    : <Fragment>
                        <div className='search-result__filter-icon-container hide-for-large' onClick={() => this.activateOverlay()}>
                            <h4>{translate('facet.header.filter')}</h4>
                            <Svg icon='filter' />
                        </div>
                        <div className="hide-for-large">
                            <FilterTag {...{ ...facetProps, navigationTheme }} productId={this.props.productId} />
                        </div>
                        <Accordion className={`compact-filter hide-for-large ${this.activeClass()}`} onClick={() => this.activateOverlay()} filters={facetFilters} clearEvent={this.props.deselectAllFilterOptions} productId={this.props.productId}>
                            {
                                subNavigation && subNavigation.links.length > 0 && !this.props.productId &&
                                <AccordionPanel header={translate('facet.header.categories')}>
                                    <SubNav subNavigation={subNavigation} />
                                </AccordionPanel>
                            }
                            {
                                facetFilters.length > 0 &&
                                facetFilters.map((group, index) =>
                                    <AccordionPanel header={group.label} key={`${group.label}-${index}`}>
                                        
                                        {
                                            group.isSlider
                                            ? <div className='input-range__container'>
                                                <RangeSlider itemValue={group.options[0]} group={group} sliderFilterChange={this.props.sliderFilterChange} productId={this.props.productId} />
                                              </div>
                                            : group.options.map((groupItem, groupIndex) =>
                                                <FacetedFilterCheckbox group={group} item={groupItem} searchFacetChange={this.props.searchFacetChange} key={groupIndex} productId={this.props.productId} />
                                              )
                                       }
                                    </AccordionPanel>
                                )
                            }
                            {
                                sortCriterias && !empty(sortCriterias) &&
                                <AccordionPanel header={translate('facet.header.sortCriteria')} icon="sorting-icon">
                                    <SortCriteriaCompact {...{ sortCriteria: sortCriterias }} />
                                </AccordionPanel>
                            }

                        </Accordion>
                        {
                            navigationTheme === 'category' && (
                                <div className='compact-filter category-theme show-for-large'>
                                    <FacetedSearchCompact {...facetState} />
                                </div>
                        )}
                       </Fragment>
                 )
        );
    }
}

const mapStateToProps = ({ facetedSearch: { subNavigation, sortCriteria, facetFilters, visibleDropdownMenu, navigationTheme, productsViewCachedId } }) => {
    return {
        subNavigation,
        sortCriteria,
        facetFilters,
        visibleDropdownMenu,
        navigationTheme,
        productsViewCachedId,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        query: (q, withHtmlResult, productId) => dispatch(query(q, withHtmlResult, productId)),
        onSubmit: (allFilters) => dispatch(submitSearchFacet(allFilters)),
        toggleVisibleDropdownMenu: (group) => dispatch(toggleVisibleDropdownMenu(group)),
        searchFacetChange: (group, item, productId) => dispatch(searchFacetChange(group, item, productId)),
        deselectAllFilterOptions: (allFilters, productId) => dispatch(deselectAllFilterOptions(allFilters, productId)),
        sliderFilterChange: (group, value) => dispatch(sliderFilterChange(group, value))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FacetedSearchCompactContainer);